import { useTranslation } from "react-i18next";

import LoadingCircle from "../../../../components/loadingCircle/LoadingCircle";
import { useUserContext } from "../../../../contexts/UserContext";
import { UserActionTypes } from "../../../../contexts/reducers/userReducer";
import useProfilesQuery from "../../../../hooks/graphql-hooks/queries/useProfileQuery";
import "./WelcomeSection.scss";

interface WelcomeSectionProps {}

const WelcomeSection = (props: WelcomeSectionProps) => {
  const { t } = useTranslation();

  const { user, dispatchUser } = useUserContext();

  const { loading } = useProfilesQuery({
    dataAction: (profile) => {
      dispatchUser({ type: UserActionTypes.SetProfile, value: profile });
    },
  });

  return (
    <div className="welcome-header" data-testid="welcome-section">
      <div className="welcome-header-name">
        {t("hello") + " "}
        {loading ? <LoadingCircle size={12} /> : user.profile?.companyName}
      </div>
      <div className="welcome-header-welcome">{t("welcomeBack")}</div>
    </div>
  );
};
export default WelcomeSection;
